import React, { useEffect, useState } from "react";
import Titlebar from "../layout/titlebar";
import { useDispatch, useSelector } from "react-redux";

import BackIcon from "../BackIcon/BackIcon";
import { paths } from "../../paths/paths";
import Lang from "../../userPreferences/staticWords";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import Button from "../sharedComponents/buttons/button";
import ResponseForm from "./ResponseForm";
import { getAllSubTask } from "../../API/services/SubPersidentalAssignment";
import { useParams } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import {
  getAllSubAssignmentsAPI,
  getAllSubTaskResponsesAPI,
  getSubAssignmentAPI,
} from "../../API/store/actions/SubPresidentalAssignment";
import CreatePresidentialDirective from "./CreatePresidentialDirective";
import { getCommunityTaskForm } from "../../API/store/actions/tasks";

const PresidentialDirectiveList = () => {
  const id = useParams().id;
  const [isEdit, setIsEdit] = useState(false);
  const [assignmentLoading, setAssignmentLoading] = useState(false);
  const [showResponses, setShowResponses] = useState({});
  const [openResponse, setOpenResponse] = useState(false);
  const [commentsLoading, setCommentsLoading] = useState({});
  const [comments, setComments] = useState({});
  const [openCreateDirective, setOpenCreateDirective] = useState(false);
  const [taskFormData, setTaskFormData] = useState(null);
  const selectedAssignment = useSelector(
    (state) => state.assignments.selectedAssignment,
  );
  const userToken = useSelector((state) => state.login.userToken);
  const user = useSelector((state) => state.login.userData);
  const subAssignments = useSelector(
    (state) => state.assignments.subAssignments,
  );
  const [selectedSub, setSelectedSub] = useState(undefined);
  const dispatch = useDispatch();
  const fetchAssignments = async () => {
    setAssignmentLoading(true);

    try {
      const payload = {
        active: true,
      };

      const action = await getAllSubAssignmentsAPI(id, userToken);
      await dispatch(action);
      console.log(subAssignments);
    } finally {
      setAssignmentLoading(false);
    }
  };
  useEffect(() => {
    const fetchTaskForm = async () => {
      const response = await getCommunityTaskForm(0, userToken);
      if (response?.payload?.data) {
        setTaskFormData(response?.payload);
      }
    };

    if (userToken) {
      fetchTaskForm();
    }
  }, [userToken, user]);
  useEffect(() => {
    fetchAssignments();
  }, []);
  const handleShowResponses = async (assignmentId) => {
    const isOpen = !!showResponses[assignmentId];

    // Toggle closed
    if (isOpen) {
      setShowResponses((prev) => ({
        ...prev,
        [assignmentId]: false,
      }));
      return;
    }

    // Open
    setShowResponses((prev) => ({
      ...prev,
      [assignmentId]: true,
    }));

    // Already loaded
    if (comments[assignmentId]) return;

    setCommentsLoading((prev) => ({
      ...prev,
      [assignmentId]: true,
    }));

    try {
      const action = await getAllSubTaskResponsesAPI(assignmentId, userToken);

      const result = await dispatch(action);

      setComments((prev) => ({
        ...prev,
        [assignmentId]: result?.payload?.data || [],
      }));
    } finally {
      setCommentsLoading((prev) => ({
        ...prev,
        [assignmentId]: false,
      }));
    }
  };
  const formatDate = (date) => {
    if (!date) return "";

    return new Intl.DateTimeFormat("ar-EG", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(new Date(date));
  };
  const ThreeDotsToggle = React.forwardRef(({ onClick }, ref) => (
    <div
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      style={{
        width: 32,
        height: 32,
        borderRadius: "50%",
        cursor: "pointer",
      }}
      className="d-flex justify-content-center align-items-center hover-bg-light"
    >
      <Icon name="ellipsis-v" size={18} color="#6c757d" />
    </div>
  ));

  ThreeDotsToggle.displayName = "ThreeDotsToggle";
  const handleAddResponse = (assignment) => {
    setSelectedSub(assignment);
    setOpenResponse(true);
  };
  return (
    <div>
      <div className="d-flex flex-column ">
        <div className="d-flex align-items-center w-100 justify-content-between  gap-2">
          <Titlebar
            title="التوجيهات الرئاسية"
            customImage={"/assets/policy-green.svg"}
          />
          <div
            className="ctr"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              margin: "0 20px",
              position: "relative",
              zIndex: "10",
            }}
          >
            <BackIcon />
          </div>
        </div>
        <div className="mt-4 col-10">
          {assignmentLoading ? (
            <div className="text-center py-4">
              <div className="spinner-border" />
            </div>
          ) : subAssignments?.length ? (
            subAssignments.map((assignment) => (
              <div
                key={assignment.id}
                className="card shadow-sm mb-4"
                style={{
                  borderRadius: 12,
                  border: "1px solid #e5e5e5",
                }}
              >
                <div className="card-body">
                  {/* Title */}
                  {/* Header */}
                  <div className="d-flex justify-content-between align-items-start ">
                    <div className="d-flex ">
                      <p className="mb-0 fs-5 fw-bold cursor-pointer">
                        {assignment.name}
                      </p>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <Dropdown align="end">
                        <Dropdown.Toggle as={ThreeDotsToggle} />

                        <Dropdown.Menu
                          style={{
                            borderRadius: 10,
                            minWidth: 180,
                            boxShadow: "0 4px 12px rgba(0,0,0,.15)",
                          }}
                        >
                          <Dropdown.Item
                            onClick={async () => {
                              const action = await getSubAssignmentAPI(
                                assignment.id,
                                userToken,
                              );

                              await dispatch(action);

                              setIsEdit(true);
                              setOpenCreateDirective(true);
                            }}
                            className="d-flex align-items-center"
                          >
                            <Icon name="edit" size={15} color="#0C574C" />
                            <span className="mx-2">تعديل التوجيه</span>
                          </Dropdown.Item>
                          {/* <Dropdown.Item
                            onClick={async () => {
                              // const action = await getAssignmentAPI(
                              //   assignment?.id,
                              //   userToken,
                              // );
                              // await dispatch(action);
                              // navigate(
                              //   `/presidential-assignments-directive/${assignment?.id}`,
                              // );
                              onAddDirective();
                            }}
                            className="d-flex align-items-center"
                          >
                            <Icon name="plus" size={15} color="#0C574C" />
                            <span className="mx-2">إضافة توجيه رئاسي </span>
                          </Dropdown.Item> */}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                  {/* Assignment Info */}
                  <div className="d-flex gap-5 flex-wrap mb-3">
                    {/* <h6 className="mb-0">رقم التكليف : {assignment.id}</h6> */}

                    <small className="text-muted">
                      تاريخ البدء: {formatDate(assignment.startDate)}
                    </small>

                    <small className="text-muted">
                      تاريخ الانتهاء: {formatDate(assignment.endDate)}
                    </small>
                  </div>

                  {/* Members */}
                  <div>
                    {/* <h6>الجهات</h6> */}

                    <div className="d-flex flex-wrap gap-2 my-2">
                      {/* {assignment.adminmember && (
                        <span
                          className="rounded-pill text-dark px-3 py-1"
                          style={{
                            background: "#f2f2f2",
                          }}
                        >
                          {assignment.adminmember.memberName}
                        </span>
                      )} */}

                      {assignment.member?.map((member) => (
                        <span
                          key={member.id}
                          className="rounded-pill text-dark px-3 py-1"
                          style={{ background: "#f2f2f2" }}
                        >
                          {member.memberName}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="text-muted mb-2">المرفقات</div>

                    {assignment.attchment?.length > 0 ? (
                      <div className="d-flex  gap-2">
                        {assignment.attchment.map((file) => (
                          <a
                            key={file.id}
                            href={`${paths.SubPresidentialTask}${assignment.id}/${file.attachment}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-decoration-none text-dark d-flex gap-2"
                          >
                            <Icon name="paperclip" size={14} />
                            <span className="mx-2">{file.attachment}</span>
                          </a>
                        ))}
                      </div>
                    ) : (
                      <span className="text-muted">لا يوجد</span>
                    )}
                  </div>
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mt-2">
                    <div className="d-flex  flex-row  col-10">
                      <Button
                        containerStyle={"col-6 col-md-1"}
                        buttonStyleType="solid"
                        customStyle={{ fontSize: 14, minWidth: 80, height: 35 }}
                        size="sm"
                        onClick={() => handleShowResponses(assignment.id)}
                        content={
                          showResponses[assignment.id]
                            ? "إخفاء الردود"
                            : "عرض الردود"
                        }
                      />
                    </div>
                    <div
                      className="d-flex align-items-center align-self-md-auto"
                      onClick={() => handleAddResponse(assignment)}
                      style={{ cursor: "pointer" }}
                    >
                      <div
                        style={{
                          backgroundColor: "#0c574b",
                          height: 26,
                          width: 26,
                          borderRadius: "50%",
                        }}
                        className="d-flex justify-content-center align-items-center plusIcon"
                      >
                        <div
                          style={{
                            width: 16,
                            height: 16,
                            background:
                              "url('/assets/images/icons/Path 184.png') center/contain no-repeat",
                            filter: "brightness(20)",
                          }}
                        />
                      </div>

                      <span className="mx-2">{Lang.addResponse}</span>
                    </div>
                  </div>
                  {showResponses[assignment.id] && (
                    <div className="mt-4">
                      {commentsLoading[assignment.id] ? (
                        <div className="text-center py-3">
                          <div className="spinner-border spinner-border-sm" />
                        </div>
                      ) : comments[assignment.id]?.length ? (
                        comments[assignment.id].map((comment) => (
                          <div
                            key={comment.id}
                            className="border rounded p-3 mb-2"
                          >
                            <div className="d-flex justify-content-between">
                              <div className="text-muted">
                                {comment.userName}
                              </div>

                              <small className="text-muted">
                                {formatDate(comment.createDate)}
                              </small>
                            </div>

                            <strong className="mt-1 fs-6">
                              {comment.description}
                            </strong>

                            {comment.attachment && (
                              <div className="mt-1">
                                <a
                                  href={`${paths.SubPresidentialTaskComment}${comment.id}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="d-flex align-items-center text-dark text-decoration-none"
                                >
                                  <Icon name="paperclip" size={14} />
                                  <span className="mx-2">
                                    {comment.attachment}
                                  </span>
                                </a>
                              </div>
                            )}
                          </div>
                        ))
                      ) : (
                        <div className="text-center text-muted py-3">
                          لا توجد ردود حتى الآن
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-4 text-muted">لا توجد بيانات</div>
          )}
        </div>
      </div>
      <CreatePresidentialDirective
        show={openCreateDirective}
        setShow={setOpenCreateDirective}
        selectedAssignment={selectedAssignment}
        isEdit={isEdit}
        onSuccess={fetchAssignments}
        members={taskFormData?.data?.members || []}
      />
      <ResponseForm
        show={openResponse}
        setShow={setOpenResponse}
        isEdit={isEdit}
        assignment={selectedSub}
        onSuccess={() => {
          fetchAssignments();
        }}
        isSubAssignment={true}
      />
    </div>
  );
};

export default PresidentialDirectiveList;
